export { default as ajax } from './ajax';
export { default as getId } from './get-id';
export { default as max } from './max';
export { default as min } from './min';
export { default as Observer } from './observer';
export { default as extend } from './extend';
export { default as style } from './style';
export { default as requestAnimationFrame } from './request-animation-frame';
export { default as frame } from './frame';
export { default as debounce } from 'debounce';



// WEBPACK FOOTER //
// ./src/util/index.js